export const dataHooks = {
  timelineListEvent: 'timeline-list-event',
  timelineLabel: 'timeline-label',
  timelineTextSuffix: 'timeline-text-suffix',
  timelineSuffix: 'timeline-suffix',
  timelineDefaultPrefix: 'timeline-default-prefix',
  timelineBulletIndicator: 'timeline-bullet-indicator',
  timelineLabelAction: 'timeline-label-action',
};

export const SKINS = {
  dark: 'dark',
  standard: 'standard',
  neutral: 'neutral',
} as const;

export const LINE_TYPES = {
  filled: 'filled',
  dashed: 'dashed',
} as const;
